import React from "react"

const LoadMoreBtn = ({ result, page, load, handleLoadMore }) => {
    return (
        <div>
            {
                result < 9 * (page - 1) ? '' :
                !load && <button className="btn btn-dark mx-auto d-block"
                onClick={handleLoadMore}>Load More</button>

            }

        </div>
    )
}

export default LoadMoreBtn